import React from "react";
import { DisplayBox } from "../../components";
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Col, Row } from "react-bootstrap";
import { AccountInterface, ApiHelper, UserHelper, ToastHelper } from "../../helpers";

interface Props {

}

export const PaymentMethod: React.FC<Props> = props => {

  const stripe = useStripe();
  const elements = useElements();
  const formStyling = { style: { base: { fontSize: "18px" } } };
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [account, setAccount] = React.useState<AccountInterface>(null);
  const [updateSuccess, setUpdateSuccess] = React.useState(false);

  const init = () => {
    ApiHelper.get("/accounts/" + UserHelper.currentDepartment.accountId).then((data: AccountInterface) => {
      setAccount(data);
    });
  }

  React.useEffect(init, [])

  const handleSave = async () => {
    setIsSubmitting(true);
    const cardData = elements.getElement(CardElement);
    const token = await stripe.createToken(cardData); // .createPaymentMethod({ type: "card", card: cardData });
    if (token.error) {
      ToastHelper.error(token.error.message);
      setIsSubmitting(false);
    }
    else {
      ApiHelper.post("/accounts/updatePaymentMethod", { token: token.token.id }).then(data => {
        ToastHelper.success("Credit card updated. Please restart your screen(s).");
        setIsSubmitting(false);
        setUpdateSuccess(true);
        init();
      });
    }
  }

  const getCurrentCardExpiration = () => {
    if (account) {
      if (account.cardExpiration) {
        const exp = new Date(account.cardExpiration);
        if (exp>new Date(2000,1,1))
        {
          exp.setDate(exp.getDate());
          return <div className="text-success" style={{ marginBottom: 5 }}>Your card on file expires {(exp.getMonth() + 1).toString().padStart(2, "0")}/{exp.getFullYear().toString().substring(2, 4)}.</div>
        }
      }
      else return <div className="text-danger" style={{ marginBottom: 5 }}>You do not currently have a card on file.</div>
    }

  }

  return (
    <DisplayBox headerText="Payment Method" headerIcon="fas fa-credit-card" >
      {getCurrentCardExpiration()}
      {!updateSuccess && (
        <Row>
          <Col sm={8}>
            <CardElement options={formStyling} />
          </Col>
          <Col sm={4} className="d-grid">
            <Button variant="primary" size="sm" className="w-100" onClick={(e) => { handleSave() }} disabled={isSubmitting}>Update</Button>
          </Col>
        </Row>
      )}

    </DisplayBox>
  );
};